import { getAuth } from "firebase/auth";
import { getApps, initializeApp } from "firebase/app";
import { firebaseConfig } from "../../..";

const QUIZ_APP_NAME = "youcat-quiz-auth";

export function getYoucatQuizAuth() {
  const quizApp =
    getApps().find((app) => app.name === QUIZ_APP_NAME) ||
    initializeApp(firebaseConfig, QUIZ_APP_NAME);

  return getAuth(quizApp);
}
